import Form from './form'
import VueLoader from '../vue-loader'

document.addEventListener('turbolinks:load', () => {
  VueLoader.loadVueComponent(Form, document.getElementById('credentialsForm'))
})
